export default __webpack_public_path__ + "static/media/puntoMall.625aa42d.svg";